/**
 * Square billing checkout client. Mirrors square-service.ts's connect flow:
 * ask the consolidated /api/square fn (routed by ?action=) for a hosted
 * checkout URL, then send the browser there. The shop + plan eligibility
 * (e.g. founders pricing) are resolved server-side from the authed owner.
 */
import { getSessionId } from './api-client';

function authHeaders(): Record<string, string> {
  const sessionId = getSessionId();
  return sessionId ? { Authorization: `Bearer ${sessionId}` } : {};
}

/** Ask the backend for a Square-hosted subscription checkout URL, then go there. */
export async function startBillingCheckout(plan: string): Promise<void> {
  const res = await fetch(`/api/square?action=billing-checkout&plan=${encodeURIComponent(plan)}`,
    { headers: authHeaders() });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.error || `Checkout failed (${res.status})`);
  }
  const { url } = await res.json();
  if (!url) throw new Error('No checkout URL returned');
  window.location.href = url;
}
